import React from 'react';
import * as Styled from './AvailableIcon.styles';

var AvailableIcon = function AvailableIcon() {
  return /*#__PURE__*/React.createElement(Styled.Icon, {
    width: "28px",
    height: "28px",
    "data-test": "attribute-selector-selected-icon",
    fill: "#0C509F",
    backgroundColor: "#FFF"
  });
};

export default AvailableIcon;